import type { TAuthorsElement } from '@shared/dream-components';
import { AuthorsElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import AuthorsProvider from './AuthorsProvider';

interface Props {
  node: TAuthorsElement;
  children: ReactNode | ReactNode[];
}

const Authors = ({ node, children }: Props) => {
  return (
    <AuthorsProvider>
      {/* biome-ignore lint/correctness/noUnusedVariables: Keep this for now */}
      {({ isLoading }) => {
        return (
          <AuthorsElement element={node} isLive={true}>
            {children}
          </AuthorsElement>
        );
      }}
    </AuthorsProvider>
  );
};

export default Authors;
